import { SoldToAddressDetailsLink } from './sold-to-address-details-link';
import React from 'react';
import { NoData } from './no-data';

export interface SoldToCompanyNameProps {
  txaId?: string;
  companyName?: string | null;
  shouldRemoveLineClamp?: boolean;
}

export const SoldToCompanyName = ({ txaId, companyName, shouldRemoveLineClamp }: SoldToCompanyNameProps) => {
  return (
    <SoldToAddressDetailsLink
      txaId={txaId}
      companyName={companyName || ''}
      shouldRemoveLineClamp={shouldRemoveLineClamp}
    >
      {companyName ?? <NoData />}
    </SoldToAddressDetailsLink>
  );
};
